import { apiInstance } from 'api/instance';

import { companyApi } from '../company';

// TRIPS: the only Trips query the sidebar (always loaded) needs -- whether
// this person has a sent trip ("My trip" + its dot). Kept apart so the main
// bundle never carries the Trips pages, the API's other endpoints or
// utils/trips; the role check is utils/trips-role.

// The rep's list tag; the trips API refreshes it when a trip is opened.
export const MY_TRIP_TAG = 'MyTrip';
export const MY_TRIP_LIST = { id: 'LIST', type: MY_TRIP_TAG } as const;

// leadsEvent: whether a Manager leads an event (false for every other
// role); missing when Main predates it.
interface HasSent {
  unread: boolean;
  hasSent: boolean;
  leadsEvent?: boolean;
}

const NOBODY: HasSent = { unread: false, hasSent: false };

export const tripsNavApi = companyApi
  .enhanceEndpoints({ addTagTypes: [MY_TRIP_TAG] })
  .injectEndpoints({
    endpoints: (build) => ({
      myTripsHasSent: build.query<HasSent, void>({
        providesTags: [MY_TRIP_LIST],
        // Before Main has the route (404), or on any error, nobody has a
        // trip: the sidebar never shows an error.
        queryFn: async (_, { signal }) => {
          try {
            const result = await apiInstance.get<HasSent>(
              'trips/mine/has-sent',
              {
                signal,
                validateStatus: (status) => status === 200 || status === 404,
              }
            );
            return { data: result.status === 200 ? result.data : NOBODY };
          } catch {
            return { data: NOBODY };
          }
        },
      }),
    }),
  });

export const { useMyTripsHasSentQuery } = tripsNavApi;
